import { HorizontalDots } from '@/resources/assets/images';
import React from 'react';
import './HorizontalDotsButton.scss';

export default function HorizontalDotsButton() {
	return (
		<div className="horizontal-dots-wrapper flex h-10 w-10 items-center justify-center rounded-lg">
			<HorizontalDots className="horizontal-dots rotate-90 lg:rotate-0" />
		</div>
	);
}
